import { z } from "zod";

export const MESSAGE_MIN = 10;
export const MESSAGE_MAX = 2000;

export const requiredMessageSchema = z.object({
  message: z
    .string()
    .trim()
    .min(MESSAGE_MIN, { message: `Message must be at least ${MESSAGE_MIN} characters.` })
    .max(MESSAGE_MAX, { message: `Message cannot exceed ${MESSAGE_MAX} characters.` }),
});

export const optionalMessageSchema = z.object({
  message: z
    .string()
    .trim()
    .max(MESSAGE_MAX, { message: `Message cannot exceed ${MESSAGE_MAX} characters.` })
    .refine((value) => value.length === 0 || value.length >= MESSAGE_MIN, {
      message: `Message must be at least ${MESSAGE_MIN} characters.`,
    }),
});

export type ContactSalesFormValues = { message: string };

export function contactSalesSchemaFor(messageRequired: boolean) {
  return messageRequired ? requiredMessageSchema : optionalMessageSchema;
}
